import { render, staticRenderFns } from "./ImportManuscript.vue?vue&type=template&id=7bdc7bd1&scoped=true"
import script from "./ImportManuscript.vue?vue&type=script&lang=js"
export * from "./ImportManuscript.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdc7bd1",
  null
  
)

export default component.exports